import { AdminRoute, RequireOrganization } from "../components/ProtectedRoute";
import { DashboardLayout } from "../components/DashboardLayout";

export default [AdminRoute, RequireOrganization, DashboardLayout];